module.exports = "/fonts/vendor/roboto-fontface/roboto/Roboto-Light.woff?c73eb1ceba3321a80a0aff13ad373cb4";